import React, { ReactElement, useState } from 'react';
import { Trans } from '@lingui/macro';
import { Paragraph } from '@mos-cat/typography';
import Checkbox from '@mos-cat/checkbox';

import Link from '../../../components/shared/Link/Link';
import { needToKnow, whatIsNextItems } from '../../../constants/iterableTexts';
import { i18n } from '../../../helpers/i18n';
import { sendFeedback } from '../../../helpers/stats';
import Feedback from '../../../components/shared/Feedback';

interface SuccessProps {
  status: string;
  eno: string;
}
export default function Success(props): ReactElement | null {
  const [checked, setChecked] = useState(false);

  const submit = (params) => {
    sendFeedback({ ...params, eno: props.eno });
    return true;
  };

  return props.status !== 'success' ? null : (
    <div>
      <h3 className="ResultPage_head">
        <Trans>Что дальше</Trans>
      </h3>
      <div className="ResultPage_list">
        {whatIsNextItems.map((child, index) => {
          return (
            <div key={index} className="ResultPage_item">
              <span className="ResultPage_item-number">{index + 1}.</span>
              {child}
            </div>
          );
        })}
        <Paragraph>
          <Trans>
            Если у вас возникнут какие-либо вопросы или затруднения — обратитесь
            в{' '}
            <Link href={'https://www.mos.ru/feedback/support/'} target="_blank">
              службу технической поддержки
            </Link>
            .
          </Trans>
        </Paragraph>
        {/*todo: удалить потом. Этот кусок кода с чекбоксом просто для показа, никакой функциональности у него
        нет, значение чекбокса никуда не отправляется
         https://rocket-chat.mos-team.ru/group/%25D0%25A3%25D0%259C%25D0%25A1?msg=fgUA8uS45W6tQnKo8*/}
        <div className="PguFormGrid__row">
          <div className="PguFormGrid_col">
            <Paragraph>
              Также вы можете выбрать дополнительный способ информирования:
            </Paragraph>
            <Checkbox
              label="Электронная почта"
              checked={checked}
              onChange={({ target: { checked } }) => {
                setChecked(checked);
              }}
            />
          </div>
        </div>
      </div>
      <>
        <Feedback
          title={'Оцените удобство подачи заявления'}
          onSubmit={submit}
        />
      </>
      <div className="no-print">
        <h3 className="ResultPage_head">
          <Trans>Полезно знать</Trans>
        </h3>
        <ul className="ResultPage_link_list">
          {needToKnow.map(({ name, url }, index) => {
            return (
              <li key={name + index} className="ResultPage_item">
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  href={i18n._(url)}
                >
                  <Trans id={name} />
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
